import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=7a752427&scoped=true&"
import script from "./group.ts?vue&type=script&lang=ts&"
export * from "./group.ts?vue&type=script&lang=ts&"
import style0 from "./Group.vue?vue&type=style&index=0&id=7a752427&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a752427",
  null
  
)

export default component.exports